<template>
  <div class="manage">
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <el-drawer :visible.sync="drawer">
      <el-form :model="form" ref="form" :rules="rules" class="edit-form">
        <div class="header-content">
          选中部门：{{ treeSelectValue.label }}
        </div>

        <div class="main-content">
          <el-form-item v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label + ':'">
            <el-input :disabled="formType === 'show'" :placeholder="'请输入' + item.label"
                      v-model="form[item.prop]"></el-input>
          </el-form-item>
          <el-form-item prop="newDefaultPassword" label="初始密码">
            <el-input :disabled="formType === 'show' || form.defaultPassword" :placeholder="'请输入初始秘密'" v-model="form.newDefaultPassword">
              <el-button slot="append" @click="onAutoPassword" :disabled="formType === 'show' || form.defaultPassword">随机</el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwd" label="当前密码" v-if="formType === 'update' && form.defaultPassword && hasSuperPermission">
            <el-input v-model="passwdShow" :disabled="formType === 'show'" readonly>
              <el-button slot="append" @click="onResetPassword">重置</el-button>
            </el-input>
          </el-form-item>

          <el-form-item prop="role" label="员工角色">
            <el-select :disabled="formType === 'show'" v-model="form.role" placeholder="请选择员工角色">
              <el-option v-for="item in roleSelectData" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="footer-content">
          <el-button type="primary" size="mini" @click="onSubmit" :disabled="!hasCommitPermission">确认</el-button>
          <el-button size="mini" @click="onCancel">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer :with-header="false" :visible.sync="drawerAddList" size="550px" :before-close="onDrawerClose">

      <div class="my-header">
        <div class="header-title-box">批量添加员工信息</div>
        <div class="btn-area">
          <span style="width: 124px"></span>
          <el-button size="small" type="primary" @click="downloadExcel">模板下载</el-button>
          <span style="width: 100px"></span>
          <el-upload ref="upload" action="#" :on-change="handleFileChange" :auto-upload="false"
                     :file-list="fileList" :multiple="false" :limit="1">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </div>
      </div>

      <el-main class="el-main">

        <el-form :model="form" ref="form" class="edit-form">
          <div class="main-content">

            <div class="table-area" v-if="userList.length > 0">
              <el-form style="padding-bottom: 10px" size="mini" v-for="(item, index) in userList" :key="index">
                <el-form-item v-for="(v, k) in excelTable" :key="k" :label="v" :required="k.indexOf('*') !== -1">
                  <el-input :disabled="true" v-model="item[k]"></el-input>
                </el-form-item>
                <el-divider></el-divider>
              </el-form>
            </div>
          </div>
        </el-form>
      </el-main>

      <el-footer>
        <div class="footer-content">
          <el-button size="mini" type="primary" v-loading.fullscreen.lock="pageloading" @click="onSubmitAddList">确认</el-button>
          <el-button size="mini" @click="onCancelAddList">取消</el-button>
        </div>
      </el-footer>

    </el-drawer>

    <div>
      <el-row class="content">
        <el-col :span="6" class="left">
          <h4 style="color: grey; margin-left: 10px;">企业组织架构</h4>
          <el-tree ref="tree" :data="treeData" default-expand-all highlight-current class="left-tree"
                   @node-click="handleNodeClick"></el-tree>
        </el-col>

        <el-col :span="18" class="right">
          <div style="color: red;">当前选择：{{ treeSelectValue == "" ? "没有选择" : treeSelectValue.label }}</div>

          <el-divider></el-divider>

          <div class="right-header">
            <div>
              <el-input prefix-icon="el-icon-search" placeholder="搜索员工姓名/手机号" style="width: 270px; cursor: pointer"
                        clearable size="mini" v-model="searchContent"/>
              <el-button type="info" plain size="mini" style="margin-left: 5px" @click="search">搜索</el-button>
              <el-button v-if="hasCommitPermission" type="danger" plain size="mini" style="margin-left: 30px"
                         @click="cleartextShow('部门员工')">明文查看
              </el-button>


            </div>

            <div>
              <el-button :disabled="!hasCommitPermission" type="primary" size="mini" @click="addNewComployee()">
                添加员工
              </el-button>
              <el-button :disabled="!hasCommitPermission" type="danger" size="mini" @click="deleteSelected()">删除选中
              </el-button>
              <el-button :disabled="!hasCommitPermission" size="mini" @click="addBatchesComployee()">批量添加
              </el-button>
              <el-button :disabled="!hasCommitPermission" :loading="qywxSyncing" size="mini" type="warning"
                         @click="syncQywxContacts()">同步企微通讯录
              </el-button>
            </div>
          </div>

          <div class="right-desc">
            <el-table :data="tableData" border @selection-change="handleSelectionChange" style="width: 100%">
              <el-table-column type="selection" width="55">
              </el-table-column>

              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="loginName" label="账号"></el-table-column>
              <el-table-column prop="title" label="职位"></el-table-column>
              <el-table-column prop="workId" label="工号"></el-table-column>
              <el-table-column v-slot="{ row }" prop="tel" label="手机号码" width="120px">
                <template v-if="phoneNumShow">{{ row.tel }}</template>
                <template v-else>{{ row.tel | phNoFilter }}</template>
              </el-table-column>
              <el-table-column prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
              <el-table-column prop="age" label="年龄" width="80px"></el-table-column>


              <el-table-column label="主管" width="80px">
                <template slot-scope="scope">
                  <el-switch :disabled="!hasCommitPermission" v-model="scope.row.switchValue"
                             @change="switchClick(scope.row)"/>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button type="success" size="mini" @click="tableShow(scope.row)">查 看</el-button>
                  <el-button type="warning" size="mini" @click="tableUpdate(scope.row)"
                             :disabled="!hasCommitPermission">修 改
                  </el-button>
                  <!-- <el-button type="warning" size="mini" @click="tableDelete(scope.row)">删 除</el-button> -->
                </template>
              </el-table-column>
            </el-table>

            <div class="pager">
              <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                             :page-size.sync="curPageSize" :pager-count="5"
                             :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                             @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {manage_mixin_table} from './manage-mixin'
import {mixin_clearPhoneNumShow, mixin_page_table} from '@/utils/mixin'
import {addEmployee, addEmployeeList, deleteEmployee, deleteEmployeeByBatch, getDepartmentEmployeeByPage, updateDepartment, updateEmployee,} from '@/api/organize-api'
import {syncWxAccountOnce} from '@/api/setting-api'
import {getAllRoleList} from "@/api/role-api";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {createRandomPassword} from "@/utils/commonUtils";

export default {
  components: {ClearPhoneNoDialog},
  mixins: [mixin_page_table, manage_mixin_table, mixin_clearPhoneNumShow],

  mounted() {
    this.loadTreeData()

    // getAllRoleList().then(({data}) => {
    //   if (data.code === 200) {
    //     this.roleList = data.data
    //     data.data.forEach((item) => {
    //       this.roleSelectData.push({value: item.id, label: item.name,})
    //     })
    //   } else {
    //     this.showServerErrMsg(data.code);
    //   }
    // }).catch(() => {
    //   this.showNetErrMsg();
    // })
  },

  data() {
    return {
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'change'},
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'change'},
        ]
      },


      searchContent: "",

      qywxSyncing: false,

      tableData: [],
      tableShowData: [],
      tableChecked: [],
      tableSelectRow: {},
      treeSelectValue: "",
      treeData: [],
      drawer: false,

      drawerAddList: false,
      formType: "",
      form: {},
      passwdShow: "******",
      formLabel: [
        {prop: "name", label: "员工姓名", width: ""},
        {prop: 'tel', label: '手机号码', width: "120px"},
        {prop: "loginName", label: "登陆账号", width: ""},
        {prop: 'title', label: '员工职位', width: ""},
        {prop: 'workId', label: '员工工号', width: ""},
        {prop: 'email', label: '员工邮箱', width: ""},
        {prop: 'age', label: '员工年龄', width: "80px"},
      ],
      userList: [],

      excelTable: {
        "*员工姓名": "员工姓名",
        "*手机号码": "手机号码",
        "*员工部门": "员工部门",
        "员工角色": "员工角色",
        "登陆账号": "登陆账号",
        "登陆密码": "登陆密码",
        "员工工号": "员工工号",
        "员工邮箱": "员工邮箱",
        "员工职位": "员工职位",
        "员工年龄": "员工年龄",
        "是否主管": '是否主管'
      },
      fileList: [],

      roleSelectData: [
        // {value: "MANAGE", label: "系统管理员"},
        // {value: "VIEW", label: "系统查看员"},
        // {value: "GUARD", label: "门岗助手"},
        {value: "STAFF", label: "员工邀约"},
      ],
      roleList: [],
      departmentTree: [],
      pageloading: false,
    };
  },

  methods: {
    search() {
      this.refreshTableData()
    },

    addNewComployee() {
      if ((this.treeSelectValue == null) || (this.treeSelectValue == "")) {
        this.$message.error('请选择员工所在部门');
        return
      }
      this.formType = "add"
      this.form = {}

      this.drawer = true
    },

    addBatchesComployee() {
      this.drawerAddList = true
    },

    deleteSelected() {

      let delEmployeeBatch = []

      this.tableChecked.forEach((item) => {
        delEmployeeBatch.push(item.id)
      })


      if (delEmployeeBatch.length < 1) {
        this.$message.error('没有选择员工');
        return
      }

      deleteEmployeeByBatch(delEmployeeBatch).then(({data}) => {
        console.log("data => ", data)
        // console.log("treeSelectValue => ", this.treeSelectValue)

        if (data.code == 200) {
          this.refreshTableData()
          this.$message.success('批量删除成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        // console.log("error => ", error)
        this.showNetErrMsg();
      })
    },

    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let hasLoginAccount = false
          if (this.form.loginName && this.form.loginName !== "") {
            hasLoginAccount = true
          }
          if (hasLoginAccount && this.form.role == null || this.form.role === "") {
            this.$message.error('可登录员工账号的角色不能为空');
            return
          }

          if (hasLoginAccount && this.form.newDefaultPassword == null || this.form.newDefaultPassword === "") {
            this.$message.error('可登录员工账号的密码不能为空');
            return
          }


          if (this.formType === "add") {
            this.onSubmitAdd();
          } else if (this.formType === "update") {
            this.onSubmitUpdate()
          } else {
            this.drawer = false
          }
        } else {
          console.log('validate error, error submit!!');
          return false;
        }
      });
    },

    onSubmitUpdate() {
      // console.log("form =>", this.form)
      let roleType = this.form.role
      let roleValue = null
      if (!["MANAGE", "VIEW", "GUARD", "STAFF"].includes(this.form.role)) {
        roleType = 'COMMON'
        roleValue = this.form.role
      }

      let postData = {
        id: this.form.id,
        name: this.form.name,
        tel: this.form.tel,
        workId: this.form.workId,
        email: this.form.email,
        age: this.form.age,
        title: this.form.title,
        roleType: roleType,
        roleValue: roleValue,
        loginName: this.form.loginName,
        defaultPassword: this.form.newDefaultPassword,
        loginPassword: this.form.newDefaultPassword,
      }

      updateEmployee(postData).then(({data}) => {
        if (data.code === 200) {
          let row = this.tableSelectRow

          for (var key in data.data) {
            // console.log("key = ", key)
            row[key] = data.data[key]
          }

          this.form = {}
          this.drawer = false
        } else if (data.code == 700) {
          this.$message.error('手机号码重复，请检查。');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        // console.log("error =>", error)
        this.showNetErrMsg();
      })
    },

    onSubmitAdd() {


      let roleType = this.form.role
      let roleValue = null
      if (!["MANAGE", "VIEW", "GUARD", "STAFF"].includes(this.form.role)) {
        roleType = 'COMMON'
        roleValue = this.form.role
      }

      let postData = {
        name: this.form.name,
        tel: this.form.tel,
        departmentId: this.treeSelectValue.id,
        workId: this.form.workId,
        email: this.form.email,
        age: this.form.age,
        title: this.form.title,
        defaultPassword: this.form.newDefaultPassword,
        loginPassword: this.form.newDefaultPassword,
        roleType: roleType,
        roleValue: roleValue,
        loginName: this.form.loginName,
      }

      addEmployee(postData).then(({data}) => {

        if (data.code === 200) {
          this.form = {}
          this.refreshTableData()
          this.drawer = false
          this.$message.success('添加成功');
        } else if (data.code == 700) {
          this.$message.error('手机号码重复，请检查。');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        // console.log("error =>", error)
        this.showNetErrMsg();
      })
    },

    onCancel() {
      this.drawer = false
    },

    handleNodeClick(data) {
      this.treeSelectValue = data
      this.refreshTableData()
    },

    syncQywxContacts() {
      this.qywxSyncing = true
      syncWxAccountOnce().then(({data}) => {
        if (data.code === 200) {
          this.$message.success("同步完成，部门与员工数据已更新")
          this.loadTreeData()
          this.refreshTableData()
        } else {
          this.$message.error("同步失败：" + (data.msg || "未知错误"))
        }
      }).catch((err) => {
        this.$message.error("同步失败：" + this.httpErrMsg(err))
      }).finally(() => {
        this.qywxSyncing = false
      })
    },

    refreshTableData() {      this.tableData = []
      if (!this.treeSelectValue) {
        return
      }
      let departmentId = this.treeSelectValue.id
      let pageNum = this.curPageIndex
      let pageSize = this.curPageSize
      let employeeName = this.searchContent ? this.searchContent : null
      getDepartmentEmployeeByPage(departmentId, pageNum, pageSize, employeeName).then(({data}) => {
        if (data.code === 200) {
          data.data.data.forEach(item => {
            item.switchValue = this.treeSelectValue.ownerId === item.id
            this.tableData.push(item)
          })
          this.totalCount = data.data.totals
        }
      }).catch(err => {
        console.log("getDepartmentEmployeeByPage => ", err)
      })
    },


    handleSelectionChange(val) {
      this.tableChecked = val
    },

    tableShow(row) {
      // console.log("row =>", row)
      this.formType = "show"
      this.form = {...row}
      this.$set(this.form, 'newDefaultPassword', row.defaultPassword)
      if (row.roleType === 'COMMON') {
        this.$set(this.form, 'role', row.roleValue)
      } else {
        this.$set(this.form, 'role', row.roleType)
      }

      if (!this.phoneNumShow) {
        this.form.tel = this.toFixShowTel(this.form.tel)
      }
      this.drawer = true
    },

    tableUpdate(row) {
      // console.log("row =>", row)
      if (!this.checkFixButtonPass("部门员工")) {
        return
      }
      this.formType = "update"


      this.tableSelectRow = row
      this.form = {...row}
      this.$set(this.form, 'newDefaultPassword', row.defaultPassword)
      if (row.roleType === 'COMMON') {
        this.$set(this.form, 'role', row.roleValue)
      } else {
        this.$set(this.form, 'role', row.roleType)
      }
      this.drawer = true
    },

    tableDelete(row) {
      // console.log("row =>", row)

      deleteEmployee(row.id).then(({data}) => {
        if (data.code === 200) {
          this.refreshTableData()
        } else {
          console.log("deleteEmployee  => ", data)
        }
      }).catch((error) => {
        console.log("error => ", error)
      })
    },

    switchClick(row) {
      if (row.switchValue) {
        this.tableData.forEach(item => {
          if (item.id !== row.id) {
            item.switchValue = false
          }
        })
      }

      let department = {
        "id": row.departmentId,
        "ownerId": row.switchValue ? row.id : -1
      }
      updateDepartment(department).then(({data}) => {
        // console.log("data =>", data)
        if (data.code === 200) {
          this.treeSelectValue.ownerId = data.data.ownerId
        } else {
          console.log("updateDepartment  => ", data)
        }
      }).catch(err => {
        console.log("error =>", err)
      })
    },

    handleFileChange(file, fileList) {
      console.log("@@@", "handleFileChange file", file, fileList);
      let result = file.name.indexOf(".xlsx")
      if (result) {
        this.dealExcel(file)
      } else {
        this.$message.error('请上传正确的表格');
      }
    },

    dealExcel(file) {
      console.log("@@@", "dealExcel file", file);
      const XLSX = require('xlsx');

      let rABS = true;
      let reader = new FileReader();
      let ctx = this
      reader.onload = function (e) {
        let data = e.target.result

        if (!rABS) data = new Uint8Array(data);
        let workbook = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
        let firstSheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[firstSheetName]
        const range = XLSX.utils.decode_range(sheet['!ref']);
        range.s.r = 1; // 从第2行开始读取数据

        const result = XLSX.utils.sheet_to_json(sheet, {range})
        console.log("@@@@", "XLSX.result", result);
        ctx.userList = result
      }
      if (rABS) reader.readAsBinaryString(file.raw); else reader.readAsArrayBuffer(file.raw);
    },

    findDepartmentId(departmentTree, departmentName) {
      if (departmentName.length === 0) {
        return null
      }
      let first = departmentName.shift()
      for (let i = 0; i < departmentTree.length; i++) {
        if (departmentTree[i].name === first) {
          if (departmentName.length === 0) {
            return departmentTree[i].id
          } else {
            return this.findDepartmentId(departmentTree[i].departments, departmentName)
          }
        }
      }
      return null
    },

    onSubmitAddList() {
      this.pageloading = true
      let employeeList = []
      let guardMap = new Map()
      for (let i = 0; i < this.userList.length; i++) {
        let item = this.userList[i]
        if (item["*员工姓名"] == null || item["*员工姓名"] === "") {
          this.$message.error('员工姓名不能为空');
          this.pageloading = false
          return
        }

        if (item["*手机号码"] == null || item["*手机号码"] === "") {
          this.$message.error('手机号码不能为空');
          this.pageloading = false
          return
        }

        if (item["*员工部门"] == null || item["*员工部门"] === "") {
          this.$message.error(item["*员工部门"] + '部门不能为空');
          this.pageloading = false
          return
        }
        let departmentId = this.findDepartmentId(this.departmentTree, item["*员工部门"].split("/"))
        if (!departmentId) {
          this.$message.error(item["*员工部门"] + " 部门不存在, 请检查,请输入完整部门路径，多级部门之间使用 ‘/’ 分割");
          this.pageloading = false
          return
        }

        let hasLoginAccount = false
        if (item["登陆账号"] && item["登陆账号"] !== "") {
          hasLoginAccount = true
        }

        if (hasLoginAccount && item["员工角色"] == null || item["员工角色"] === "") {
          this.$message.error('可登录员工账号的角色不能为空');
          this.pageloading = false
          return
        }


        if (hasLoginAccount && item["登陆密码"] == null || item["登陆密码"] === "") {
          this.$message.error('可登录员工账号的密码不能为空');
          this.pageloading = false
          return
        }

        if (item["登陆密码"] === "随机") {
          item["登陆密码"] = Math.random().toString(36).substr(2, 6)
        }

        if (hasLoginAccount && item["员工角色"] == null || item["员工角色"] === "") {
          this.$message.error('可登录员工账号的员工角色不能为空');
          this.pageloading = false
          return
        }

        if (hasLoginAccount) {
          let role = this.roleSelectData.find(role => role.label === item["员工角色"])
          if (!role) {
            this.$message.error(item["*员工姓名"] + '员工角色不存在, 请检查');
            this.pageloading = false
            return
          }
          if (!["MANAGE", "VIEW", "GUARD", "STAFF"].includes(role.value)) {
            item.roleType = 'COMMON'
            item.roleValue = role.value
          } else {
            item.roleType = role.value
            item.roleValue = null
          }

        }


        let postItem = {
          name: item["*员工姓名"],
          tel: item["*手机号码"],
          email: item["员工邮箱"],
          departmentId: departmentId,
          loginName: item["登陆账号"],
          workId: item["员工工号"],
          age: item["员工年龄"],
          title: item["员工职位"],
          defaultPassword: item["登陆密码"],
          loginPassword: item["登陆密码"],
          roleType: item.roleType,
          roleValue: item.roleValue,
        }

        employeeList.push(postItem)
        if (item["是否主管"] && item["是否主管"].includes("是")) {
          guardMap.set(departmentId, postItem)
        }
      }

      console.log("@@@", employeeList)
      console.log("@@@ guardMap", guardMap)
      addEmployeeList(employeeList).then(({data}) => {
        console.log("addEmployeeList =>", data)
        this.pageloading = false
        if (data.code === 200) {
          if (guardMap.size > 0) {
            this.dealGuardMap(guardMap, data.data)
          } else {
            if (this.treeSelectValue) {
              this.handleNodeClick(this.treeSelectValue)
            }
          }

          this.userList = {}
          this.fileList = []
          this.drawerAddList = false
          this.$message.success('批量添加上传成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(() => {
        this.showNetErrMsg();
        this.pageloading = false
      })

    },

    async dealGuardMap(guardMap, employeeList) {
      // 遍历 map
      for (const [key, value] of guardMap) {
        console.log(key, value)
        let employee = employeeList.find(item => item.tel === value.tel.toString())
        if (employee) {
          let postData = {id: key, ownerId: employee.id}
          try {
            let res = await updateDepartment(postData)
            console.log("updateDepartment res =>", res)
          } catch (error) {
            console.log("error =>", error)
          }
        }
      }
      this.handleNodeClick("")
      this.loadTreeData()
    },


    onCancelAddList() {
      this.userList = []
      this.drawerAddList = false
      this.fileList = []
    },

    downloadExcel() {

      const path = "/static/temp/员工创建模板.xlsx"
      let link = document.createElement('a');
      link.style.display = 'none';
      link.download = '员工创建模板.xlsx';
      link.href = path;
      link.click();

      URL.revokeObjectURL(link.href);
    },

    onDrawerClose(done) {
      this.userList = []
      this.drawerAddList = false
      this.fileList = []
      done()
    },

    onAutoPassword() {
      console.log("onAutoPassword")
      let password = createRandomPassword()
      this.$set(this.form, 'newDefaultPassword', password)
    },

    onResetPassword() {
      console.log("onResetPassword")
      let postData = {
        id: this.form.id,
        loginPassword: this.form.defaultPassword,
      }
      updateEmployee(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success('重置成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        this.showNetErrMsg();
      })

    },

    hasSuperPermission() {
      return this.$store.state.roleType === "ADMIN"
    },
  },

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("EMPLOYEE_MANAGE_MODIFY")
        default:
          return false
      }
    }
  },


}

</script>

<style lang="less" scoped>
.el-footer {
  text-align: center;
  line-height: 60px;
}

.my-header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 150px;

  .header-title-box {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.el-main {
  height: calc(100% - 220px);
  box-sizing: border-box;
  padding: 0;
}

.table-area {
  margin-top: 20px;
}

.btn-area {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;

}

.el-form-item {
  display: flex;
  justify-content: flex-start;

  /deep/ .el-form-item__label {
    width: 100px;
  }

  /deep/ .el-input {
    width: calc(20vw);
  }
}

.header-content {
  margin-bottom: 20px;

}

.manage {

  .edit-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: start;
    height: 100%;

    .main-content {
      flex: 1 0 auto;

    }

    .footer-content {
      text-align: center;
      flex: 0 0 auto;
      margin-bottom: 20px;
    }
  }

  .content {
    display: flex;
    justify-content: space-between;

    .left {
      margin: 0 20px 0 0;

      //border-left: 1px solid #efefef;
      border-right: 1px solid #efefef;
      box-shadow: 2px 2px 2px 2px #efefef;
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      //margin-top: 20px;
      //margin-bottom: 18px;
      //margin-right: 20px;

      .right-header {
        display: flex;
        justify-content: space-between;

        margin-bottom: 20px;
      }

      .right-desc {
        /deep/ .el-table__body-wrapper {
          min-height: calc(100vh - 340px);
          // height: 700px;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
          /*width: 0;宽度为0隐藏*/
          width: 0px;
        }
      }
    }
  }
}

.left-tree {
  height: calc(100vh - 240px);
  overflow-y: auto;
}
</style>
